import { loadCss, loadJs } from 'bits/load'

declare var katex: any

const scriptUrl = 'https://cdn.jsdelivr.net/npm/katex@0.13.11/dist/katex.min.js'
const styleUrl = 'https://cdn.jsdelivr.net/npm/katex@0.13.11/dist/katex.min.css'

export async function mathifyElement(elem: HTMLElement): Promise<void> {
  await Promise.all([loadJs(scriptUrl), loadCss(styleUrl)])
  katex.render(elem.innerText, elem, { displayMode: false })
}
